import { Injectable } from '@angular/core';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { VelaroProvider } from '../provider/velaro.provider';
import { SessionService } from '@monsido/core/session/session.service';
import { EventsType } from '@monsido/services/mon-event/events.type';

@Injectable({
    providedIn: 'root',
})
export class VelaroRunService {
    constructor (
        private monEventService: MonEventService,
        private velaroProvider: VelaroProvider,
        private sessionService: SessionService,
    ) {}

    public setupEventListeners (): void {
        this.monEventService.addListener('afterCustomer' as EventsType, () => {
            if (this.sessionService.getChatSystem() === 'velaro' && !this.sessionService.isSudo) {
                this.velaroProvider.addScript();
            }
        });
    }
}
